import * as React from 'react';

const SvgUsersCircule = (props) => (
  <svg
    width={72}
    height={72}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width={72} height={72} rx={36} fill='#fff' />
    <path
      d='M31.997 22.667A6.34 6.34 0 0 0 25.664 29c0 3.427 2.68 6.2 6.173 6.32a1.07 1.07 0 0 1 .294 0h.093A6.317 6.317 0 0 0 38.331 29a6.34 6.34 0 0 0-6.334-6.333ZM38.777 38.867c-3.72-2.48-9.787-2.48-13.533 0-1.694 1.133-2.627 2.666-2.627 4.306 0 1.64.933 3.16 2.613 4.28 1.867 1.254 4.32 1.88 6.774 1.88 2.453 0 4.907-.626 6.773-1.88 1.68-1.133 2.614-2.653 2.614-4.306-.014-1.64-.934-3.16-2.614-4.28ZM46.653 29.787c.213 2.586-1.627 4.853-4.174 5.16h-.066c-.08 0-.16 0-.227.026-1.294.067-2.48-.346-3.373-1.106 1.373-1.227 2.16-3.067 2-5.067a6.188 6.188 0 0 0-1.027-2.907 4.79 4.79 0 0 1 6.867 3.893Z'
      fill='#E00034'
    />
    <path
      d='M49.323 42.12c-.107 1.294-.933 2.413-2.32 3.174-1.333.733-3.013 1.08-4.68 1.04.96-.867 1.52-1.947 1.627-3.094.133-1.653-.654-3.24-2.227-4.507-.893-.706-1.933-1.266-3.067-1.68 2.947-.853 6.654-.28 8.934 1.56 1.226.987 1.853 2.227 1.733 3.507Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgUsersCircule;
